/**
 * Converts a raw SVG string into a `data:image/svg+xml` URI usable directly as OL's `icon-src`.
 * Uses `encodeURIComponent` (not base64) for readability/debuggability of the resulting style JSON.
 * No tinting is baked in here — tinting is entirely OL's runtime job via `icon-color`.
 */
export function svgToDataUri(svgMarkup: string): string {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgMarkup)}`;
}

/**
 * Resolves a data-URI `icon-src` back to its dictionary key by comparing decoded markup against
 * `dictionary`'s entries — only succeeds for URIs produced by {@link svgToDataUri} from that same
 * dictionary. A style saved by another producer (AI-generated, hand-authored, ...) with an
 * equivalent-but-differently-encoded `icon-src` returns undefined rather than throwing.
 */
export function resolveIconKeyFromDataUri(src: unknown, dictionary: Record<string, string>): string | undefined {
  if (typeof src !== "string" || !src.startsWith("data:image/svg+xml")) return undefined;
  let decoded: string;
  try {
    decoded = decodeURIComponent(src.slice(src.indexOf(",") + 1));
  } catch {
    return undefined;
  }
  return Object.keys(dictionary).find((key) => dictionary[key] === decoded);
}
